import {
  put, takeEvery, all, call,
} from 'redux-saga/effects';
import SettingsDealTemplateApi from './settings-deal-template.api';
import ErrorFormatService from '../../../services/error-format-service';
import {
  GET_DEAL_TEMPLATE_DATA, GET_DEAL_TEMPLATE_DATA_SUCCESS, GET_DEAL_TEMPLATE_DATA_ERROR,
  SAVE_DEAL_TEMPLATE_DATA, SAVE_DEAL_TEMPLATE_DATA_SUCCESS, SAVE_DEAL_TEMPLATE_DATA_ERROR,
} from '../../../constants/system/actions';

export function* getDealTemplateData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SettingsDealTemplateApi.getDealTemplateData, payload);
    yield put({ type: GET_DEAL_TEMPLATE_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: GET_DEAL_TEMPLATE_DATA_ERROR, error });

    if (reject) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export function* saveDealTemplateData(action: ReduxAction): Generator<ReduxAction> {
  const { payload, resolve, reject } = action;

  try {
    const data: ActionResponse | null = yield call(SettingsDealTemplateApi.saveDealTemplateData, payload);
    yield put({ type: SAVE_DEAL_TEMPLATE_DATA_SUCCESS, data });

    if (resolve) {
      resolve();
    }
  } catch (error: GraphQLError) {
    yield put({ type: SAVE_DEAL_TEMPLATE_DATA_ERROR, error });

    if (reject && !ErrorFormatService.isFormError(error)) {
      reject(ErrorFormatService.getGraphQLErrorInstance({ ...error }));
    }
  }
}

export default function* settingsDealTemplateSagas(): Generator<ReduxAction> {
  yield all([
    takeEvery(GET_DEAL_TEMPLATE_DATA, getDealTemplateData),
    takeEvery(SAVE_DEAL_TEMPLATE_DATA, saveDealTemplateData),
  ]);
}
